import React, { useContext, useState } from "react";
import { ButtonProps, AddButton, Aside } from "sprint-common-web";

import { TvSeriesContext } from "../../details/context/TvSeriesContext";
import { CreateTvSeriesForm } from "../create-form/CreateTvSeriesForm";
import { TvSeriesListingItem } from "../TvSeriesListingItem";

export type CreateTvSeriesButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    isLabeled?: boolean;
    onTvSeriesCreated?(newTvSeries: TvSeriesListingItem): void;
};

export const CreateTvSeriesButton: React.FunctionComponent<CreateTvSeriesButtonProps> = (
    props: CreateTvSeriesButtonProps
) => {
    const tvSeriesContext = useContext(TvSeriesContext);
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsAsideOpen(true);
    };

    const closeCreateSeasonSidebar = () => {
        setIsAsideOpen(false);
    };

    const handleCreateSeasonFormSubmit = (tvSeries: TvSeriesListingItem) => {
        if (props.onTvSeriesCreated) {
            props.onTvSeriesCreated(tvSeries);
        }
        closeCreateSeasonSidebar();
    };

    return (
        <>
            <AddButton
                onClick={handleClick}
                isLabeled={props.isLabeled}
                label="Add"
                disabled={props.disabled || tvSeriesContext.isLoading}
                styles={props.styles}
            />
            <Aside isOpen={isAsideOpen} type="form" headerText="Add Tv Series" onDismiss={closeCreateSeasonSidebar}>
                <CreateTvSeriesForm onCancel={closeCreateSeasonSidebar} onSubmit={handleCreateSeasonFormSubmit} />
            </Aside>
        </>
    );
};
